module.exports = __webpack_public_path__ + "static/media/business-and-trade.056d4d3d.svg";